import { CalendarTask } from '@infodata-group/inf-commons';

export class ResizingEvent {
  public viewTask: { style: any; task: CalendarTask };
  public event: MouseEvent;
  public direction: 'top' | 'bottom';

  constructor(
    viewTask: { style: any; task: CalendarTask },
    event: MouseEvent,
    direction: 'top' | 'bottom',
  ) {
    this.viewTask = viewTask;
    this.event = event;
    this.direction = direction;
  }
}
